import { REST_API } from '../../constants/restUrls';
import HttpConnection from '../../utils/http-connection';

/**
 * Function use for call api login
 *
 * @param {object} userInfo
 */
export function login(userInfo) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .post(REST_API.COMMON.LOGIN, userInfo)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

export function getMe() {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.COMMON.ME)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
